import React, { useState } from 'react';
import { useLocation } from "react-router-dom";
import removeAccents from 'remove-accents';
import * as R from 'ramda';
import Dropzone from 'react-dropzone';
import filesrc from './../../assets/images/svg/039-file.svg';
import { FiletypeToDisplayName, FileTypes } from '../../constants/utils/fileTypes';
// import { ModalPartager } from './partager';

export const UploadArea = ({ documentName, documentType, documentDescription, uploadedFile, downloadFile, uploadFile, deleteFile, autoupload, selectable, setSelectFiles, selectedFiles, labelName, telechargerArea, modalTelechargerArea, toggleTelechargerArea, editDescription }) => {

    const [files, setFiles] = useState([]);
    const [description, setDescription] = useState("");
    const location = useLocation();

    if (!R.isNil(uploadedFile)) {
        // let description = R.isNil(uploadedFile.description) || R.isEmpty(uploadedFile.description) || uploadedFile.description === "undefined" ? 'Pas de description' : uploadedFile.description;
        let description = R.isNil(uploadedFile.description) || R.isEmpty(uploadedFile.description) || uploadedFile.description === "undefined" ? uploadedFile.fileName : uploadedFile.description;
        
        if(uploadedFile.fileType === FileTypes.Payslip){
            const descriptionParts = description.split("_");
            if(descriptionParts[descriptionParts.length - 1].toLowerCase() === "payslip"){
                description = "Bulletin de paie"
            }
            if(/^\d+$/.test(descriptionParts[descriptionParts.length - 2])){
                description = "Bulletin de paie " + descriptionParts[descriptionParts.length - 2].substring(0, 6);
            }
        }
        return location.pathname.includes("biblioteque") ? (
					<div className="card border-0 rounded upload-card">
						<div className="card-body flex-column p-3 gap-2 my-auto">
							<div className="flex-row flex-grow-1 gap-3 my-auto">
								{
									R.isNil(uploadedFile.fileType) || R.isEmpty(uploadedFile.fileType) ? "" : <h3 className="fs-1 o-60 my-auto text-uppercase font-weight-bold ls-2">{R.isNil(documentType) ? FiletypeToDisplayName(uploadedFile.fileType) : documentType}</h3>

									//<h3 className="fs-1 o-60 my-auto text-uppercase font-weight-bold ls-2">{FiletypeToDisplayName(uploadedFile.fileType)}</h3>
								}
								{selectable === true && (
									<div className="custom-control custom-checkbox checkbox-cc ml-auto mr-n1" role="button">
										<input
											type="checkbox"
											className="custom-control-input"
											id={uploadedFile.fileName}
											onChange={() => {
												const fileFullName = R.isNil(uploadedFile.path) ? uploadedFile.fileName : uploadedFile.fileType === FileTypes.Payslip ? "RH:" + uploadedFile.description + "/" + uploadedFile.fileName : uploadedFile.path + "/" + uploadedFile.fileName;
												if (selectedFiles.indexOf(fileFullName) === -1) {
													setSelectFiles([...selectedFiles, fileFullName]);
												} else {
													setSelectFiles(selectedFiles.filter((s) => s !== fileFullName));
												}
											}}
										/>
										<label className="custom-control-label text-none border-gray fs-0 ml-1" htmlFor={uploadedFile.fileName}>
											Select
										</label>
									</div>
								)}
							</div>
							<div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
								<div className="rounded-max bg-light d-inherit h-6 w-6 rounded-max text-center flex-shrink-0 m-auto">
									{/* <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i> */}
									<img
										className="img-fluid h-4 m-auto"
										src={filesrc}
										alt="file"
										onClick={(e) => {
											e.preventDefault();
											downloadFile(uploadedFile);
										}}
									/>
								</div>
								<div className="flex-column flex-fill my-auto text-truncate">
									<p className={"fs-root mb-0 lh-copy mt-auto text-truncate" + (R.isNil(uploadedFile.description) || R.isEmpty(uploadedFile.description) || uploadedFile.description === "undefined" ? " o-80" : "")}>{description}</p>
									<h3 className="small mb-0 lh-copy my-auto o-30 text-truncate" key={uploadedFile.fileName}>
										{uploadedFile.fileName}
									</h3>
								</div>

								<div className="btn-group">
									<button type="button" className="btn btn-square btn-mix text-inherit border-0 rounded-sm my-auto flex-shrink-0" data-toggle="dropdown" aria-expanded="false">
										<i className="eva eva-more-vertical-outline fs-root lh-1 align-middle"></i>
									</button>
									<div className="dropdown-menu dropdown-menu-right shadow-lg gap-1 border-0 p-2">
										{uploadedFile.fileType === FileTypes.Payslip ? (
											<>
												<button
													type="button"
													className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
													onClick={() => {
														downloadFile(uploadedFile);
													}}>
													<span className="ls-n3">Télécharger</span>
												</button>
											</>
										) : (
											<>
												<button
													type="button"
													className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
													onClick={() => {
														deleteFile(uploadedFile);
														setFiles([]);
													}}>
													<span className="ls-n3">Supprimer</span>
												</button>
												<button
													type="button"
													className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
													onClick={() => {
														editDescription(uploadedFile);
													}}>
													<span className="ls-n3">Renommer</span>
												</button>
												<button
													type="button"
													className="w-100 mb-1 btn text-left bg-light--hover btn-if p-2 rounded-sm border-none"
													onClick={() => {
														downloadFile(uploadedFile);
													}}>
													<span className="ls-n3">Télécharger</span>
												</button>
											</>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="card rounded upload-card">
						<div className="card-body text-center py-4 my-auto">
							<img
								role="button"
								className="img-fluid h-5 mx-auto mt-auto mb-2"
								src={filesrc}
								alt="file"
								onClick={(e) => {
									e.preventDefault();
									downloadFile(uploadedFile);
								}}
							/>
							<div className="container-tight mx-auto mb-auto pt-xs">
								{R.isNil(uploadedFile.fileType) || R.isEmpty(uploadedFile.fileType) ? "" : <h3 className="fs-1 o-60 mb-1 text-uppercase font-weight-bold ls-2">{FiletypeToDisplayName(uploadedFile.fileType)}</h3>}
								<p className="lh-copy text-lowercase mb-2" key={uploadedFile.fileName}>
									{uploadedFile.fileName}
								</p>
								<p className="fs-3 text-gray">{R.isNil(uploadedFile.description) || uploadedFile.description === "undefined" ? "" : uploadedFile.description}</p>
								{selectable === true ? (
									<div className="custom-control custom-checkbox checkbox-cc mt-2">
										<input
											type="checkbox"
											className="custom-control-input"
											id={uploadedFile.fileName}
											onChange={() => {
												if (selectedFiles.indexOf(uploadedFile.fileName) === -1) {
													setSelectFiles([...selectedFiles, uploadedFile.fileName]);
												} else {
													setSelectFiles(selectedFiles.filter((s) => s !== uploadedFile.fileName));
												}
											}}
										/>
										<label className="custom-control-label text-none border-gray fs-0 ml-1" htmlFor={uploadedFile.fileName}>
											Select
										</label>
									</div>
								) : (
									""
								)}

								{/*<ModalPartager /> */}
							</div>
							<button
								type="button"
								className="btn btn-alert-danger btn-square border-none rounded-sm trash-btn"
								onClick={() => {
									deleteFile(uploadedFile);
									setFiles([]);
								}}>
								<i className="eva eva-trash-2-outline fs-3"></i>
							</button>
						</div>
					</div>
				);
    }

    if (files.length > 0) {
        return location.pathname.includes("biblioteque") ? (
					<div className={"card rounded upload-card" + (modalTelechargerArea ? " border-0 bg-light" : " border-0")}>
						<div className="card-body flex-column p-3 gap-2 my-auto">
							{R.sortBy(R.compose(R.toLower, R.prop("name")))(files)
								.map((file) => (
								<React.Fragment key={file.name}>
										{/* <h3 className="fs-1 o-60 mb-1 text-uppercase font-weight-bold ls-2">{file.fileType}</h3> */}
										<div className="flex-row flex-grow-1 gap-3 my-auto" role="button">
											<div className={"rounded-max d-inherit h-6 w-6 rounded-max text-center flex-shrink-0 m-auto" + (modalTelechargerArea ? " bg-white" : " bg-light")}>
												{/* <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i> */}
												<img className="img-fluid h-4 m-auto" src={filesrc} alt="file" />
											</div>
											<div className="flex-column flex-fill my-auto">
												<h3 className="fs-root mb-0 lh-copy mt-auto" key={file.name}>
													{file.name}
												</h3>
												<div className="block flex-row mt-1 mb-auto">
													{/* <i role="button" className="eva eva-trash-2-outline trash-btn mr-1" onClick={() => { setFiles([]); }}></i> */}
													<input
														type="text"
														className={"fs-2 form-control border-0 form-control-sm my-auto px-2" + (modalTelechargerArea ? " bg-white" : " bg-light")}
														placeholder="description"
														onChange={(e) => {
															e.preventDefault();
															setDescription(e.target.value);
														}}
													/>
													{modalTelechargerArea && (
														<button
															type="button"
															className="btn btn-alert-danger trash-btn border-none rounded-sm mr-0"
															onClick={() => {
																setFiles([]);
															}}>
															<i className="eva eva-trash-2-outline fs-aux lh-1"></i>
														</button>
													)}
												</div>
											</div>
										</div>
									</React.Fragment>
								))}
							{(!modalTelechargerArea || toggleTelechargerArea) && (
								<div className="flex-row gap-3 justify-content-between align-items-center">
									{toggleTelechargerArea ? (
										<button type="button" className="btn btn-if btn-alert-secondary border-none fs-tiny p-1 order-last" data-toggle="modal" data-target="#telecharger">
											<i className="btn-ico eva eva-paper-plane-outline btn-white-secondary text-secondary rounded no-event fs-inherit"></i>
											<span className="align-middle mx-2">Cliquer pour enregistrer</span>
										</button>
									) : (
										<button
											type="button"
											className="btn btn-if btn-alert-secondary border-none fs-tiny p-1 order-last"
											onClick={(e) => {
												e.preventDefault();
												const file = files[0];
												const reader = new FileReader();
												//uploadFile
												reader.onload = async () => {
													let blob = reader.result;
													uploadFile(new File([blob], removeAccents(file.name).toLowerCase().replace(/\s/gi, "")), description);
													setFiles([]);
												};
												reader.readAsArrayBuffer(file);
											}}>
											<i className="btn-ico eva eva-paper-plane-outline btn-white-secondary text-secondary rounded no-event fs-inherit"></i>
											<span className="align-middle mx-2">Cliquer pour enregistrer</span>
										</button>
									)}
									<button
										type="button"
										className="btn p-0 btn-link text-gray fs-tiny"
										onClick={() => {
											setFiles([]);
										}}>
										Annuler{" "}
									</button>
								</div>
							)}
						</div>
					</div>
				) : (
					<div className="card rounded upload-card">
						<div className="card-body text-center py-4 my-auto">
							<img className="img-fluid h-5 mx-auto mt-auto mb-2" src={filesrc} alt="file" />
							<div className="container-tight mx-auto mb-auto pt-1">
								{files.map((file) => (
									<h3 className="small mb-0 lh-copy" key={file.name}>
										{file.name}
										{/* {file.name} - {file.size} bytes */}
									</h3>
								))}
							</div>

							<i
								role="button"
								className="eva eva-trash-2-outline trash-btn"
								onClick={() => {
									setFiles([]);
								}}></i>
							<input
								type="text"
								className="small o-50 form-control form-control-sm mt-2 mb-3 px-2"
								placeholder="description"
								onChange={(e) => {
									e.preventDefault();
									setDescription(e.target.value);
								}}
							/>
							<button
								type="button"
								className="btn-alert-secondary btn btn-sm"
								onClick={(e) => {
									e.preventDefault();
									const file = files[0];
									const reader = new FileReader();
									//uploadFile
									reader.onload = async () => {
										let blob = reader.result;
										uploadFile(new File([blob], removeAccents(file.name).toLowerCase().replace(/\s/gi, "")), description);
										setFiles([]);
									};
									reader.readAsArrayBuffer(file);
								}}>
								<i className="eva eva-paper-plane-outline lh-1 align-middle rounded"></i> Cliquer pour enregistrer
							</button>
							<br />
							<button
								type="button"
								className="btn btn-sm btn-link text-gray p-0 mt-2 fs-3"
								onClick={() => {
									setFiles([]);
								}}>
								Annuler{" "}
							</button>
						</div>
					</div>
				);
    }

    return (
        (location.pathname.includes("biblioteque")) ?
            telechargerArea ?
                modalTelechargerArea ?
                    <div className="card border-0 shadow-xs--hover rounded upload-card btn-alert-secondary" data-toggle="modal" data-target="#telecharger">
                        <div className="card-body flex-row gap-3 my-auto py-0" role="button">
                            <div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-white text-secondary">
                                <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
                            </div>
                            <div className="flex-column flex-fill my-auto">
                                <h3 className="fs-root mb-0 lh-copy my-auto">{documentName}</h3>
                                <p className={"small o-60 mb-0 lh-copy my-auto" + (modalTelechargerArea ? "" : " container-up")}>{labelName ? labelName : "Aucun document"}</p>
                            </div>
                        </div>
                    </div>
                    :
                    <div className="card border-0 shadow-xs--hover rounded upload-card btn-alert-secondary">
                        <Dropzone onDrop={acceptedFiles => {
                            if (autoupload) {
                                const reader = new FileReader();
                                //uploadFile
                                reader.onload = async () => {
                                    let blob = reader.result;
                                    uploadFile(new File([blob], removeAccents(acceptedFiles[0].name).toLowerCase().replace(/\s/gi, "")), description);
                                    setFiles([]);
                                };
                                reader.readAsArrayBuffer(acceptedFiles[0]);
                            } else {
                                setFiles(acceptedFiles);
                            }
                        }} accept={"application/pdf"}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <div className="card-body flex-row gap-3 my-auto" role="button">
                                        <div className="rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0 bg-white text-secondary">
                                            <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
                                        </div>
                                        <div className="flex-column flex-fill my-auto">
                                            <h3 className="fs-root mb-0 lh-copy my-auto">{documentName}</h3>
                                            <p className="small o-60 mb-0 lh-copy my-auto container-up">{labelName ? labelName : "aucun document"}</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Dropzone>
                    </div>
                :
                <div className={"card rounded upload-card border-0" + (modalTelechargerArea ? " bg-light" : " bg-mix bg-white--hover shadow-xs--hover")}>
                    <Dropzone onDrop={acceptedFiles => {
                        if (autoupload) {
                            const reader = new FileReader();
                            //uploadFile
                            reader.onload = async () => {
                                let blob = reader.result;
                                uploadFile(new File([blob], removeAccents(acceptedFiles[0].name).toLowerCase().replace(/\s/gi, "")), description);
                                setFiles([]);
                            };
                            reader.readAsArrayBuffer(acceptedFiles[0]);
                        } else {
                            setFiles(acceptedFiles);
                        }
                    }} accept={"application/pdf"}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <div className="card-body flex-row gap-3 my-auto" role="button">
                                    <div className={"rounded-max d-inherit h-6 w-6 rounded-max text-center my-auto flex-shrink-0" + (modalTelechargerArea ? " bg-white" : " bg-dim")}>
                                        <i className="eva eva-cloud-upload-outline h1 lh-1 m-auto o-60"></i>
                                    </div>
                                    <div className="flex-column flex-fill my-auto">
                                        <h3 className="fs-root mb-0 lh-copy my-auto">{documentName}</h3>
                                        <p className={"small o-60 mb-0 lh-copy my-auto" + (modalTelechargerArea ? "" : " container-up")}>{labelName ? labelName : "Aucun document"}</p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Dropzone>
                </div>

            :
            //is-uploading
            <div className="card rounded upload-card">
                <Dropzone onDrop={acceptedFiles => {
                    if (autoupload) {
                        const reader = new FileReader();
                        //uploadFile
                        reader.onload = async () => {
                            let blob = reader.result;
                            uploadFile(new File([blob], removeAccents(acceptedFiles[0].name).toLowerCase().replace(/\s/gi, "")), description);
                            setFiles([]);
                        };
                        reader.readAsArrayBuffer(acceptedFiles[0]);
                    } else {
                        setFiles(acceptedFiles);
                    }
                }} accept={"application/pdf"}>
                    {({ getRootProps, getInputProps }) => (
                        <div {...getRootProps()}>
                            <input {...getInputProps()} />
                            <div className="card-body text-center py-4 my-auto" role="button">
                                <i className="eva eva-cloud-upload-outline h1 lh-1 mt-auto o-60"></i>
                                <div className="container-tiny mx-auto mb-auto">
                                    <h3 className="small mb-0 lh-copy mt-n1">{documentName}</h3>
                                </div>
                            </div>
                        </div>
                    )}
                </Dropzone>
            </div>
    );
};